import { useState } from 'react'

export function ApplicationStep1a({ setShowPreQualifyQuestions, handleApplicationPreQualify }) {
  const [isSelfEmployed, setIsSelfEmployed] = useState('')
  
  return  (
    <div className='w-full h-full flex flex-col items-center lg:justify-center mt-10 max-sm:mt-5 overflow-y-auto'>
      <div className='w-full h-full flex flex-col items-center justify-center px-4 py-6 mt-10'>
        <p className='lg:text-2xl text-xl font-bold text-center mb-8'>
          Were you self-employed, a sole proprietor, a 1099 independent contractor, freelancer, and/or gig worker in 2021?
        </p>
        <div className='flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-10 mb-10'>
          <label className='flex items-center space-x-3 cursor-pointer'>
            <input
              type='radio'
              name='employmentStatus'
              value='Yes'
              checked={isSelfEmployed === 'Yes'}
              onChange={() => setIsSelfEmployed('Yes')}
              className='form-radio text-setcg h-5 w-5'
            />
            <span className='text-lg'>Yes</span>
          </label>
          <label className='flex items-center space-x-3 cursor-pointer'>
            <input
              type='radio'
              name='employmentStatus'
              value='No'
              checked={isSelfEmployed === 'No'}
              onChange={() => setIsSelfEmployed('No')}
              className='form-radio text-setcg h-5 w-5'
            />
            <span className='text-lg'>No</span>
          </label>
        </div>
        <div className='flex flex-row items-center gap-4'>
          <button
            onClick={() => setShowPreQualifyQuestions(false)}
            className='px-8 py-2 text-white rounded-md transition-colors duration-200 bg-red-500 hover:bg-red-600'>
            Back
          </button>
          <button
            onClick={() => handleApplicationPreQualify('isSelfEmployed', isSelfEmployed)}
            disabled={!isSelfEmployed}
            className={`px-8 py-2 text-white rounded-md transition-colors duration-200 ${!isSelfEmployed ? 'bg-gray-400' : 'bg-primaryColor hover:bg-primaryDarkColor transition duration-200'}`}>
            Next
          </button>
        </div>
      </div>
    </div>
  )
}